// Typelizer digest 933e5a81a538926b6a4618cfeb6f4835
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/payments/sync_accounts */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/payments/sync_accounts', {}, options),
    method: 'post',
  }),
}
